import { reactive, toRefs } from 'vue';

export default function useDeleteConfirm() {
    const state = reactive({
        deleteConfirm: {
            id: null,
            visible: false,
            item: '',
        },
    });

    const resetDeleteConfirm = () => {
        state.deleteConfirm = {
            id: null,
            visible: false,
            item: '',
        };
    }

    const showDeleteConfirm = (list, id, fieldName) => {
        resetDeleteConfirm();
        const item = (list || []).find((listItem) => listItem.id === id);
        if (item) {
            state.deleteConfirm = {
                id,
                visible: true,
                item: item[fieldName],
            };
        }
    };

    return {
        ...toRefs(state),
        showDeleteConfirm,
        hideDeleteConfirm: resetDeleteConfirm,
    };
}
